import { render, staticRenderFns } from "./epms3030.vue?vue&type=template&id=272073f4&scoped=true"
import script from "./epms3030.vue?vue&type=script&lang=js"
export * from "./epms3030.vue?vue&type=script&lang=js"
import style0 from "./epms3030.vue?vue&type=style&index=0&id=272073f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "272073f4",
  null
  
)

export default component.exports